/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClassifyProductTagsQueryVariables = Exact<{
  name: string;
  subFamily: string;
  brand?: string | null | undefined;
  description?: string | null | undefined;
  labels?: Array<string> | string | null | undefined;
  genericProductCode?: string | null | undefined;
}>;


export type ClassifyProductTagsQuery = { classifyProductTags: { status: string, tagCodes: Array<string> | null, reason: string | null } | null };


export const ClassifyProductTagsDocument = /*#__PURE__*/ gql`
    query ClassifyProductTags($name: String!, $subFamily: String!, $brand: String, $description: String, $labels: [String!], $genericProductCode: String) {
  classifyProductTags(
    name: $name
    subFamily: $subFamily
    brand: $brand
    description: $description
    labels: $labels
    genericProductCode: $genericProductCode
  ) {
    status
    tagCodes
    reason
  }
}
    `;

/**
 * __useClassifyProductTagsQuery__
 *
 * To run a query within a React component, call `useClassifyProductTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassifyProductTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassifyProductTagsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      subFamily: // value for 'subFamily'
 *      brand: // value for 'brand'
 *      description: // value for 'description'
 *      labels: // value for 'labels'
 *      genericProductCode: // value for 'genericProductCode'
 *   },
 * });
 */
export function useClassifyProductTagsQuery(baseOptions: Apollo.QueryHookOptions<ClassifyProductTagsQuery, ClassifyProductTagsQueryVariables> & ({ variables: ClassifyProductTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassifyProductTagsQuery, ClassifyProductTagsQueryVariables>(ClassifyProductTagsDocument, options);
      }
export function useClassifyProductTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassifyProductTagsQuery, ClassifyProductTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassifyProductTagsQuery, ClassifyProductTagsQueryVariables>(ClassifyProductTagsDocument, options);
        }
// @ts-ignore
export function useClassifyProductTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClassifyProductTagsQuery, ClassifyProductTagsQueryVariables>): Apollo.UseSuspenseQueryResult<ClassifyProductTagsQuery, ClassifyProductTagsQueryVariables>;
export function useClassifyProductTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassifyProductTagsQuery, ClassifyProductTagsQueryVariables>): Apollo.UseSuspenseQueryResult<ClassifyProductTagsQuery | undefined, ClassifyProductTagsQueryVariables>;
export function useClassifyProductTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassifyProductTagsQuery, ClassifyProductTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClassifyProductTagsQuery, ClassifyProductTagsQueryVariables>(ClassifyProductTagsDocument, options);
        }
export type ClassifyProductTagsQueryHookResult = ReturnType<typeof useClassifyProductTagsQuery>;
export type ClassifyProductTagsLazyQueryHookResult = ReturnType<typeof useClassifyProductTagsLazyQuery>;
export type ClassifyProductTagsSuspenseQueryHookResult = ReturnType<typeof useClassifyProductTagsSuspenseQuery>;
export type ClassifyProductTagsQueryResult = Apollo.QueryResult<ClassifyProductTagsQuery, ClassifyProductTagsQueryVariables>;